// An incursive function to take routes and return the child element with path === :orgName and return the children
export const findOrgRoutes = (routes) => {
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].path === ':orgName') {
      return routes[i].children?.filter((route) => !!route.path)
    } else if (routes[i].children) {
      // Keep scanning siblings when this subtree doesn't contain :orgName —
      // returning unconditionally would let any earlier route with children
      // (e.g. the top-level /me route) shadow the org routes entirely.
      const found = findOrgRoutes(routes[i].children)
      if (found) {
        return found
      }
    }
  }
}
